export default "__VITE_ASSET__lC3kpozD__"